import Symbol           from 'es6-symbol/polyfill';
import EventEmitter     from 'events';
import axios            from 'axios';
import SearchService from '@/front/services/search';

let singleton = Symbol();
let singletonEnforcer = Symbol();

class FacetsService extends EventEmitter {

  //________________________________________________________ constructor
  // -
  constructor(pEnforcer) {
    if (pEnforcer !== singletonEnforcer) {
      throw 'Cannot construct singleton';
    }
    super();
    this.loadedFacets = [];
    SearchService.on('update-selectedFacets', () => this.get() );
  }

  static getInstance() {
    if (!this[singleton]) {
      this[singleton] = new FacetsService(singletonEnforcer);
    }
    return this[singleton];
  }

  _onSuccessFacets(res) {
    this.loadedFacets = SearchService.openedFacets.map( facet => facet.id);
    this.emit('updated', res.data);
  }

  filter(facetId, search = null , afterId = null) {
    const params = {
      ...SearchService.paramsFacets
    }
    if( afterId ) params.after = afterId;
    if( search ) params.contentLike = search;
    return axios.get(`/api/v2/facets/${facetId}/children`, { params });
  }

  getTree() {
    const params = {
      ...SearchService.paramsFacets
    };
    const seq = axios.get('/api/v2/facets/tree', {params: params });
    seq.then( res => this._onSuccessFacets(res))
    seq.catch( console.error )
    return seq;
  }
}
export default FacetsService.getInstance();